import { StorageCache } from './types';

const getItemFromSessionStore = <T> (key: string) => {
    const localStore = window.sessionStorage;
    const item = localStore.getItem(key);

    if (item && item !== null && item !== '') {
        return JSON.parse(item) as T;
    }

    return undefined;
};

const setItemInSessionStore = <T> (item: T, key: string) => {
    const localStore = window.sessionStorage;
    localStore.setItem(key, JSON.stringify(item));
};

const removeItemFromSessionStore = (key: string) => {
    const localStore = window.sessionStorage;
    localStore.removeItem(key);
};

const clearSessionStore = () => {
    const localStore = window.sessionStorage;
    localStore.clear();
};

const SessionStorageCache = ()
: StorageCache => ({
    getItem: getItemFromSessionStore,
    setItem: setItemInSessionStore,
    removeItem: removeItemFromSessionStore,
    clear: clearSessionStore,
});

export default SessionStorageCache;
